/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Offline_Kind_DeleteInputs */

const en_us2_offline_kind_delete = /** @type {(inputs: Offline_Kind_DeleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Set removal`)
};

const pt_br2_offline_kind_delete = /** @type {(inputs: Offline_Kind_DeleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remoção de série`)
};

const es_419_offline_kind_delete = /** @type {(inputs: Offline_Kind_DeleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eliminación de serie`)
};

const pt_pt2_offline_kind_delete = /** @type {(inputs: Offline_Kind_DeleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remoção de série`)
};

const fr_fr2_offline_kind_delete = /** @type {(inputs: Offline_Kind_DeleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suppression de série`)
};

const de_de2_offline_kind_delete = /** @type {(inputs: Offline_Kind_DeleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Satz entfernt`)
};

const it_it2_offline_kind_delete = /** @type {(inputs: Offline_Kind_DeleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rimozione serie`)
};

/**
* | output |
* | --- |
* | "Set removal" |
*
* @param {Offline_Kind_DeleteInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const offline_kind_delete = /** @type {((inputs?: Offline_Kind_DeleteInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offline_Kind_DeleteInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_offline_kind_delete(inputs)
	if (locale === "es-419") return es_419_offline_kind_delete(inputs)
	if (locale === "pt-PT") return pt_pt2_offline_kind_delete(inputs)
	if (locale === "fr-FR") return fr_fr2_offline_kind_delete(inputs)
	if (locale === "de-DE") return de_de2_offline_kind_delete(inputs)
	if (locale === "it-IT") return it_it2_offline_kind_delete(inputs)
	return en_us2_offline_kind_delete(inputs)
});
export { offline_kind_delete as "offline.kind_delete" }